var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper",attrs:{"id":"content"}},[_c('b-overlay',{attrs:{"show":_vm.show,"variant":_vm.variant,"rounded":"sm"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }